<template>
    <div class="container">
      <div class="content py-4">
        <div class="contract_name mb-4">{{ contract.digital_contract_name }}</div>
        <p class="fw-bold">簽約人：</p>
        <div>甲方： {{ contract.party_a_name }}</div>
        <div>乙方： {{ contract.party_b_name }}</div>
        <br>

        <div class="contract_content" v-html="contract.content"></div>
        <br>
        <br>
        <p class='fw-bold fs-4'>簽約人： </p>
          <div class="ps-4">
            <div class="info-wrap"><div class="title fw-bold">甲方：</div> {{ contract.party_a_name }}</div>
            <div class="info-wrap"><div class="title">登記地址：</div> {{ contract.party_a_address }}</div>
            <div class="info-wrap"><div class="title">統一編號：</div> {{ contract.party_a_vat_number }}</div>
            <div class="info-wrap"><div class="title">代表人：</div> {{ contract.party_a_representative }}</div>
            <div class="info-wrap"><div class="title">通訊地址：</div> {{ contract.party_a_contact_address }}</div>
            <div class="info-wrap"><div class="title">聯絡人：</div> {{ contract.party_a_contact }}</div>
            <div class="info-wrap"><div class="title">聯絡電話：</div> {{ contract.party_a_phone }}</div>
            <div class="info-wrap"><div class="title">Email：</div> {{ contract.party_a_email }}</div>
            <br>
            <br>
            <div class="info-wrap"><div class="title fw-bold">乙方：</div> {{ contract.party_b_name }}</div>
            <div class="info-wrap"><div class="title">登記地址：</div> {{ contract.party_b_address }}</div>
            <div class="info-wrap"><div class="title">統一編號：</div> {{ contract.party_b_vat_number }}</div>
            <div class="info-wrap"><div class="title">代表人：</div> {{ contract.party_b_representative }}</div>
            <div class="info-wrap"><div class="title">通訊地址：</div> {{ contract.party_b_contact_address }}</div>
            <div class="info-wrap"><div class="title">聯絡人：</div> {{ contract.party_b_contact }}</div>
            <div class="info-wrap"><div class="title">聯絡電話：</div> {{ contract.party_b_phone }}</div>
            <div class="info-wrap"><div class="title">Email：</div> {{ contract.party_b_email }}</div>
          </div>

          <br>
          <div class="date">{{ formatDate(contract.contract_date) }}</div>

      </div>
    </div>
</template>



<script>

// import axios from 'axios';
// const token = localStorage.getItem('token');
// axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

// var currentURL = (document.URL);
// const sgid = currentURL.split('://')[1].split('/')[3];
// const uuid = currentURL.split('://')[1].split('/')[2];
// const checksum = currentURL.split('://')[1].split('/')[4];
// const baseUrl = process.env.VUE_APP_API_URL
// const getContractUrl = `${baseUrl}/api/v1/signing_digital_contract/${uuid}/${sgid}/${checksum}.json`

export default {
  name: 'MainBody',
  props: {
    contract: {
     type: Object,
    },
  },
  data() {
    return {
    }
  },
  mounted () {
    // console.log('trp',this.$route.params);
    // axios
    //   .get(getContractUrl)
    //   .then(response => {
    //     this.contract = response.data.digital_contract
    //     this.resData = response.data
    //     this.checksumIsValid = response.data.checksum_is_valid

    //   })
    //   console.log('res');
    //   console.log(baseUrl);
  },
  methods: {
    formatDate(dateString) {
            const date = new Date(dateString);
            let year = date.getFullYear();
            year = Number(year)-1911
            let mon = date.getMonth();
            mon = mon+1
            const day = date.getDate();
            const ouput = `中華民國 ${year} 年 ${mon} 月 ${day} 日`
                // Then specify how you want your dates to be formatted
            return ouput
    },
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
.contract_name{
  font-size: 24px;
  font-weight: 600;
}
.content{
  text-align: left;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.75;

}
.info-wrap{
  display: flex;
  // margin-bottom: 20px;
  .title{
    margin-right: 10px;
  }
}
.date{
  padding: 15px;
  text-align: center;
}
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
